module.exports = __webpack_public_path__ + "static/media/wxgraph_output_1.643d4f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WxGraphTool/wxgraph_output_1.png
// module id = 1774
// module chunks = 0